import { CURRENCY, LOCALE_REQUIRED, MEASUREMENT } from "dpfv";
import { InferType, array, boolean, number, object, string } from "yup";

import { PRODUCT_TYPE } from "@/types";

export const SearchFormSchema = object({
  locale: LOCALE_REQUIRED(),
  category: array(string()),
  type: string().oneOf([PRODUCT_TYPE.PROJECT, PRODUCT_TYPE.PROPERTY_TYPE]),
  propertyType: array(string()),
  bedrooms: array(string()),
  bathrooms: array(string()),
  price: array(number()),
  area: array(number()),
  minimumUnitArea: number(),
  maximumUnitArea: number(),
  status: string(),
  isFurnished: boolean(),
  unitViews: array(string()),
  deliveryDate: array(string()),
  features: array(string()),
  lifeStyle: array(string()),
  brands: array(string()),
  others: array(string()),
  offers: array(string()),
  year: array(string()),
  currency: CURRENCY(),
  measurement: MEASUREMENT(),
  onlyAvailable: boolean(),
  // onlineExclusive: string().oneOf(["", "false", "true"]).optional(),
});

export type SearchFormSchemaType = InferType<typeof SearchFormSchema>;
